import React from "react";
import { Link } from "react-router-dom";
const AnchorTag = ({ aText, aClass, aHref, aTarget }) =>
 
(
    
<a href={aHref} className={aClass} target={aTarget}>
        {aText}
    </a>
);

export default AnchorTag;
